export default __webpack_public_path__ + "static/media/AWS_Pattern_Blueprint-Blocks-A_Light-BG_Blue.83a1b5f6.png";